const AUTH_TOKEN_KEY = 'auth_token';
const AUTH_CLAIMS_KEY = 'auth_claims';

export const parseJwt = (token) => {
  if (!token || typeof token !== 'string') {
    return null;
  }

  const parts = token.split('.');
  if (parts.length !== 3) {
    return null;
  }

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const paddedBase64 = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    const json = decodeURIComponent(
      atob(paddedBase64)
        .split('')
        .map((character) => `%${(`00${character.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join('')
    );

    return JSON.parse(json);
  } catch (error) {
    return null;
  }
};

export const getStoredAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY);

export const getStoredAuthClaims = () => {
  const storedClaims = localStorage.getItem(AUTH_CLAIMS_KEY);
  if (!storedClaims) {
    return null;
  }

  try {
    return JSON.parse(storedClaims);
  } catch (error) {
    return null;
  }
};

export const storeAuthSession = (token) => {
  const claims = parseJwt(token);
  localStorage.setItem(AUTH_TOKEN_KEY, token);

  if (claims) {
    localStorage.setItem(AUTH_CLAIMS_KEY, JSON.stringify(claims));
  } else {
    localStorage.removeItem(AUTH_CLAIMS_KEY);
  }

  return claims;
};

export const clearAuthSession = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_CLAIMS_KEY);
};

export const isAdminUser = (claims) => {
  if (!claims || claims.role !== 'admin') {
    return false;
  }

  const customerId = Number(claims.customer_id);
  return customerId === 0;
};